export const computeCoverProperties = (container, aspectRatio) => {
	const containerAspectRatio = container.offsetWidth / container.offsetHeight;

	const width =
		aspectRatio < containerAspectRatio
			? container.offsetWidth
			: container.offsetHeight * aspectRatio;
	const height =
		aspectRatio < containerAspectRatio
			? container.offsetWidth / aspectRatio
			: container.offsetHeight;
	const top = (container.offsetHeight - height) / 2;
	const left = (container.offsetWidth - width) / 2;

	return {
		top,
		left,
		width,
		height,
	};
};

export const addSuffixToProperties = (properties, suffix = "px") =>
	Object.entries(properties).reduce((acc, [key, value]) => {
		return { ...acc, [key]: `${value}${suffix}` };
	}, {});

export const computeCoverPropertiesWithSuffix = (
	wrapper,
	ratio,
	suffix = "px",
) => addSuffixToProperties(computeCoverProperties(wrapper, ratio), suffix);



// WEBPACK FOOTER //
// ./scripts/modules/media.js